import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import AddUserSvg from '../assets/svgs/addUser';

import PermissionForm from '../sections/users/permissionForm';
import pageTitle from '../utils/pageTitles.json';
import { PermissionContext } from '../context/PermissionContext';
import DetailsForm from '../sections/users/detailsForm';
import { axiosGetCall, axiosPostCall } from '../services/apisCall';

import { renderErrorMessage, renderSuccessMessage } from '../lib/toastMessage';
import { ToastContainer } from 'react-toastify';

const logger = new Logger('kycListTable');
import Logger from '../lib/Logger';

//@mui
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

const MainSection = styled('div')(() => ({
  width: '100%',
  padding: '64px 20px 0px 88px',
  backgroundColor: 'rgb(240, 240, 240)' /* theme.palette.background.default */,
  height: '100vh',
}));

const MainSectionInner = styled('div')(() => ({
  backgroundColor: '#fff',
  padding: '30px 20px',
  borderRadius: '6px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  height: `calc(${window.innerHeight}px - 157px)`,
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
  width: '100%',
  padding: '20px 0px 20px 0px',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
}));

const AddNewUser = () => {
  const {
    permission: { access: adminAccess = {}, tabPanel = {} },
  } = useContext(PermissionContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [userType, setUserType] = useState('');
  const [group, setGroup] = useState('');
  const [password, setPassword] = useState('');
  const [canAcceptAm, setCanAcceptAm] = useState(false);
  const { edit, email: userEmail, behalf: behalfEmail } = location?.state || {};
  const [addUserLoader, setAddUserLoader] = useState(false);
  const [accessArray, setAccessArray] = useState({});
  const [allTabPanel, setAllTabPanel] = useState({});
  const [selectedEmail, setSelectedEmail] = useState('');
  const [originalAccessArray, setOriginalAccessArray] = useState({});

  // Fetch all permissions from DB — source of truth, not JWT
  const fetchAllTabs = async () => {
    const { tabs, tabPanel: fetchedTabPanel } = await axiosGetCall('getPanelPermission');
    setAllTabPanel(fetchedTabPanel);
    return Object.values(tabs).reduce((acc, tab) => {
      acc[tab.id] = { r: false, w: false, title: tab.title, key: tab.key, id: tab.id };
      return acc;
    }, {});
  };

  const getUserAccess = async () => {
    try {
      const [allTabs, { access, role, group: userGroup, can_accept_am }] = await Promise.all([
        fetchAllTabs(),
        axiosGetCall('getUserAccess', { email: userEmail }),
      ]);

      // Start from all DB permissions (r/w = false), overlay target user's actual access
      const mergedAccess = Object.keys(allTabs).reduce((acc, id) => {
        acc[id] = access[id]
          ? { ...allTabs[id], r: access[id].r ?? false, w: access[id].w ?? false }
          : allTabs[id];
        return acc;
      }, {});

      setAccessArray(mergedAccess);
      setOriginalAccessArray(JSON.parse(JSON.stringify(mergedAccess)));
      setUserType(role);
      setEmail(userEmail);
      setGroup(userGroup);
      setCanAcceptAm(can_accept_am || false);
    } catch (error) {
      logger.error('addNewUser.jsx getUserAccess', error);
      renderErrorMessage(error?.message);
    }
  };

  useEffect(() => {
    if (edit) {
      getUserAccess();
    } else {
      fetchAllTabs().then(setAccessArray).catch((e) => logger.error('addNewUser fetchAllTabs', e));
    }
  }, []);

  const handleAccess = (page, key, accessType, bool) => {
    let object = { ...access };
    object[page][key][accessType] = bool;
    setAccess(object);
  };

  const handleAddUser = async () => {
    try {
      setAddUserLoader(true);

      const cloneArray = JSON.parse(JSON.stringify(accessArray));

      Object.keys(cloneArray).map((id) => {
        delete cloneArray[id].title;
      });

      Object.keys(cloneArray).map((id) => {
        if (!cloneArray[id].r && !cloneArray[id].w) delete cloneArray[id];
      });

      const params = { access: cloneArray, role: userType, email, group, behalf: selectedEmail, password, can_accept_am: canAcceptAm };
      let message;

      if (edit) {
        const permissionsToSend = {};

        // Send changed permissions (added, updated, or toggled off)
        Object.keys(accessArray).forEach((id) => {
          const current = accessArray[id];
          const original = originalAccessArray[id];

          if (!original || current.r !== original.r || current.w !== original.w) {
            permissionsToSend[id] = { r: current.r, w: current.w, id: current.id, title: current.title };
          }
        });

        // Send { r: false, w: false } for keys that existed before but are no longer in the panel
        Object.keys(originalAccessArray).forEach((id) => {
          if (!accessArray[id]) {
            permissionsToSend[id] = { r: false, w: false };
          }
        });

        const paramsForUpdate = {
          access: permissionsToSend,
          role: userType,
          email,
          group,
          behalf: selectedEmail,
          can_accept_am: canAcceptAm,
        };
        if (password) paramsForUpdate.password = password;
        message = await axiosPostCall('updateUserDetails', paramsForUpdate);
      } else {
        message = await axiosPostCall('createAdminUser', params);
      }
      renderSuccessMessage(message?.message);
      setTimeout(() => {
        navigate('/users');
      }, 1000);
    } catch (error) {
      logger.error('addNewUser.jsx ,handleAddUser ,createAdminUser', error);
      renderErrorMessage(error?.message);
    } finally {
      setAddUserLoader(false);
    }
  };

  return (
    <>
      <Helmet>
        <title> {`${pageTitle?.addNewUser}`} </title>
      </Helmet>
      {/* <ToastContainer /> */}
      <MainSection>
        <HeadingSection>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '10px',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                widht: '16px',
                height: '16px',
                mt: -1.8,
              }}
            >
              <AddUserSvg />
            </Box>
            <Typography variant="h5" sx={{ color: 'grey.10', fontWeight: 600 }}>
              Add New User
            </Typography>
          </Box>
        </HeadingSection>

        <MainSectionInner>
          <DetailsForm
            addUserLoader={addUserLoader}
            email={email}
            setEmail={setEmail}
            userType={userType}
            setUserType={setUserType}
            group={group}
            setGroup={setGroup}
            handleAddUser={handleAddUser}
            edit={edit}
            selectedEmail={selectedEmail}
            setSelectedEmail={setSelectedEmail}
            behalf={behalfEmail}
            password={password}
            setPassword={setPassword}
            canAcceptAm={canAcceptAm}
            setCanAcceptAm={setCanAcceptAm}
          />

          {Object.keys(accessArray)?.length > 0 && (
            <PermissionForm
              accessArray={accessArray}
              setAccessArray={setAccessArray}
              tabPanel={Object.keys(allTabPanel).length ? allTabPanel : tabPanel}
              adminAccess={adminAccess}
              handleAccess={handleAccess}
              edit={edit}
            />
          )}
        </MainSectionInner>
      </MainSection>
    </>
  );
};

export default AddNewUser;
